export const generateUUID = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    // eslint-disable-next-line
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })

export const camelToTitleCase = str =>
  str
    // Insert space before upper case letters
    .replace(/([A-Z])/g, match => ` ${match}`)
    // Capitalize first letter
    .replace(/^./, match => match.toUpperCase())

export const dashToTitleCase = str =>
  str
    // Replace hyphen with space
    .replace(/-/g, " ")
    // Temporarily split string by spaces
    .split(" ")
    // Capitalize each word
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    // Join words again
    .join(" ")
